import { render, staticRenderFns } from "./DataSources.vue?vue&type=template&id=a58da9da&scoped=true"
import script from "./DataSources.vue?vue&type=script&lang=js"
export * from "./DataSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58da9da",
  null
  
)

export default component.exports